import { DbUserBasicInfos } from "./db-user-basic-infos";
import { AuthMode } from "./auth-mode";
import { DbSearchHistoryInfos } from "./db-search-history-infos";
import { immerable } from "immer";
import { UserLoginStartup } from "./user-login-startup";
import { Language } from "../../../i18n";

export enum ShowMode {
  Table = "Table",
  Thumbs = "Thumbs",
}

export enum AppTheme {
  Dark = "Dark",
  Light = "Light",
}

export enum NotificationUserSubscribe {
  ShareFirstView = "ShareFirstView",
  DownloadLinkTransfer = "DownloadLinkTransfer",
}

export class UserPreferences {
  showMode: ShowMode = ShowMode.Table;
  theme: AppTheme = AppTheme.Dark;
  notifications: NotificationUserSubscribe[] | null = null;
  audioTracksList: boolean = false;
  lang: Language = Language.English;

  constructor(init?: Partial<UserPreferences>) {
    Object.assign(this, init);
  }
}

export class DbUserInfos extends DbUserBasicInfos {
  [immerable] = true;
  isSynced: boolean | null = null;
  isVerified: boolean | null = null;
  passwordErrorCount: number | null = 0;
  platformId: number | null = 0;
  lastPasswordChange: Date | null = null;
  notes: string | null = null;
  forgotPasswordKey: string | null = null;
  expireDate: Date | null = null;
  login: string = "";
  password: string | null = null;
  phone: string | null = null;
  authMode: AuthMode | null = null;
  customerIds: number[] | null = null;
  searchHistory: DbSearchHistoryInfos[] | null = null;
  item: Object | null = null;
  startup: UserLoginStartup | null = null;
  picture: any | null = null;
  prefs: UserPreferences | null = null;
  cof: Date | null = null;
  isExternalAccessSpecific: boolean = false;

  constructor(init?: Partial<DbUserInfos>) {
    super();
    Object.assign(this, init);
  }
}
